/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Activity_v1 from '../components/Activity_v1';
import Activity_v2 from '../components/Activity_v2';
import AllCarhomePage from '../components/AllCar-homePage';
import Appliance_v1 from '../components/Appliance_v1';
import Banner_v1 from '../components/Banner_v1';
import Banner_v2 from '../components/Banner_v2';
import BlackEdition_v1 from '../components/BlackEdition_v1';
import BreezeHeader_v1 from '../components/BreezeHeader_v1';
import BuyCar_v1 from '../components/BuyCar_v1';
import BuyCar_v3 from '../components/BuyCar_v3';
import BuyCar_v4 from '../components/BuyCar_v4';
import BuyCar_v5 from '../components/BuyCar_v5';
import CarComparisonTab_v1 from '../components/CarComparisonTab_v1';
import CarComparisonTab_v2 from '../components/CarComparisonTab_v2';
import CarComparison_v1 from '../components/CarComparison_v1';
import CarRecommend_v1 from '../components/CarRecommend_v1';
import Center_v1 from '../components/Center_v1';
import Choose_v1 from '../components/Choose_v1';
import Close_v1 from '../components/Close_v1';
import Close_v2 from '../components/Close_v2';
import Contrast_v1 from '../components/Contrast_v1';
import Contrast_v2 from '../components/Contrast_v2';
import Detail_v1 from '../components/Detail_v1';
import Detail_v2 from '../components/Detail_v2';
import Drive_v1 from '../components/Drive_v1';
import EnvironmentAnnouncement_v1 from '../components/EnvironmentAnnouncement_v1';
import EnvironmentInformation_v1 from '../components/EnvironmentInformation_v1';
import Environment_v1 from '../components/Environment_v1';
import EventDisplay_v1 from '../components/EventDisplay_v1';
import ExhibitionHall from '../components/ExhibitionHall';
import ExhibitionHall_v1 from '../components/ExhibitionHall_v1';
import ExhibitionHall_v2 from '../components/ExhibitionHall_v2';
import ExhibitionHall_v3 from '../components/ExhibitionHall_v3';
import Exterior_accord from '../components/Exterior_accord';
import FinancialCalculator_v1 from '../components/FinancialCalculator_v1';
import FinancialService_v1 from '../components/FinancialService_v1';
import FindDealer_v1 from '../components/FindDealer_v1';
import Footer from '../components/Footer';
import FooterhomePage from '../components/Footer-homePage';
import FooterBlack_v2 from '../components/FooterBlack_v2';
import FooterFixmeau_v1 from '../components/FooterFixmeau_v1';
import Footer_black from '../components/Footer_black';
import Footer_v1 from '../components/Footer_v1';
import FullVideo_v1 from '../components/FullVideo_v1';
import FullVideo_v2 from '../components/FullVideo_v2';
import H5_v1 from '../components/H5_v1';
import Header from '../components/Header';
import HeaderhomePage from '../components/Header-homePage';
import HeaderBlack_v2 from '../components/HeaderBlack_v2';
import Header_black from '../components/Header_black';
import Header_v1 from '../components/Header_v1';
import HeroSupport_v1 from '../components/HeroSupport_v1';
import HomeBanner from '../components/HomeBanner';
import HomeTabs_v1 from '../components/HomeTabs_v1';
import Home_v1 from '../components/Home_v1';
import HybridAlliancehomePage from '../components/HybridAlliance-homePage';
import ImageGroup_v1 from '../components/ImageGroup_v1';
import ImageHorizontalScoll_v1 from '../components/ImageHorizontalScoll_v1';
import ImageReplace_v1 from '../components/ImageReplace_v1';
import ImageSlide_v1 from '../components/ImageSlide_v1';
import Inlet_v1 from '../components/Inlet_v1';
import InnerPageFace_v1 from '../components/InnerPageFace_v1';
import InnerPageLists_v1 from '../components/InnerPageLists_v1';
import InnerPageSensingLists_v1 from '../components/InnerPageSensingLists_v1';
import InnerPageSourceList_v1 from '../components/InnerPageSourceList_v1';
import InnerPageVideoLists_v1 from '../components/InnerPageVideoLists_v1';
import Insurance_v1 from '../components/Insurance_v1';
import Interaction_v1 from '../components/Interaction_v1';
import Interaction_v2 from '../components/Interaction_v2';
import Interior_accord from '../components/Interior_accord';
import Interior_accord_v1 from '../components/Interior_accord_v1';
import Ipfilm_v1 from '../components/Ipfilm_v1';
import KnowledgeDetail_v1 from '../components/KnowledgeDetail_v1';
import Knowledge_v1 from '../components/Knowledge_v1';
import KvTabs_v4 from '../components/KvTabs_v4';
import kv_v1 from '../components/kv_v1';
import kv_v2 from '../components/kv_v2';
import kv_v3 from '../components/kv_v3';
import Kv_v4 from '../components/Kv_v4';
import LargeImageContentAll_v1 from '../components/LargeImageContentAll_v1';
import LifeValuehomePage from '../components/LifeValue-homePage';
import Live_v1 from '../components/Live_v1';
import Manual_v1 from '../components/Manual_v1';
import Media_v1 from '../components/Media_v1';
import Media_v2 from '../components/Media_v2';
import MobileApp_v1 from '../components/MobileApp_v1';
import ModelComparison_v1 from '../components/ModelComparison_v1';
import NavigationBreezeHeader_v1 from '../components/NavigationBreezeHeader_v1';
import NavigationHeader_v1 from '../components/NavigationHeader_v1';
import NavigationMachine_v1 from '../components/NavigationMachine_v1';
import NavigationMachine_v2 from '../components/NavigationMachine_v2';
import NavigationMachine_v3 from '../components/NavigationMachine_v3';
import NavigationSide_v1 from '../components/NavigationSide_v1';
import NewsDetail_v1 from '../components/NewsDetail_v1';
import News_v1 from '../components/News_v1';
import NotFound_v1 from '../components/NotFound_v1';
import OneOnOne_v1 from '../components/OneOnOne_v1';
import OneOnOne_v2 from '../components/OneOnOne_v2';
import OneOnOne_v3 from '../components/OneOnOne_v3';
import Opention_v1 from '../components/Opention_v1';
import Operation from '../components/Operation';
import Operation_footer from '../components/Operation_footer';
import Operation_footer_v2 from '../components/Operation_footer_v2';
import Operation_footer_v5 from '../components/Operation_footer_v5';
import Operation_footer_v6 from '../components/Operation_footer_v6';
import Operation_footer_v7 from '../components/Operation_footer_v7';
import Operation_main from '../components/Operation_main';
import Operation_Main_v2 from '../components/Operation_Main_v2';
import Operation_main_v3 from '../components/Operation_main_v3';
import OverlayImage_v1 from '../components/OverlayImage_v1';
import PartPrice_v1 from '../components/PartPrice_v1';
import Picture_v1 from '../components/Picture_v1';
import Policy_v1 from '../components/Policy_v1';
import Power_v1 from '../components/Power_v1';
import PriceControl_v1 from '../components/PriceControl_v1';
import priceExterior_v1 from '../components/priceExterior_v1';
import PriceExterior_v10 from '../components/PriceExterior_v10';
import PriceExterior_v11 from '../components/PriceExterior_v11';
import priceExterior_v2 from '../components/priceExterior_v2';
import PriceExterior_v3 from '../components/PriceExterior_v3';
import PriceExterior_v4 from '../components/PriceExterior_v4';
import PriceExterior_v5 from '../components/PriceExterior_v5';
import PriceExterior_v6 from '../components/PriceExterior_v6';
import PriceExterior_v7 from '../components/PriceExterior_v7';
import PriceExterior_v8 from '../components/PriceExterior_v8';
import PriceExterior_v9 from '../components/PriceExterior_v9';
import PricePower_v1 from '../components/PricePower_v1';
import PricePower_v2 from '../components/PricePower_v2';
import PricePower_v3 from '../components/PricePower_v3';
import PricePower_v4 from '../components/PricePower_v4';
import PricePower_v5 from '../components/PricePower_v5';
import PricePower_v6 from '../components/PricePower_v6';
import PricePower_v7 from '../components/PricePower_v7';
import PricePower_v8 from '../components/PricePower_v8';
import PriceSafety_v1 from '../components/PriceSafety_v1';
import PriceSpace_inlet from '../components/PriceSpace_inlet';
import PriceSpace_v1 from '../components/PriceSpace_v1';
import PriceSpace_v10 from '../components/PriceSpace_v10';
import PriceSpace_v11 from '../components/PriceSpace_v11';
import PriceSpace_v3 from '../components/PriceSpace_v3';
import PriceSpace_v4 from '../components/PriceSpace_v4';
import PriceSpace_v5 from '../components/PriceSpace_v5';
import PriceSpace_v6 from '../components/PriceSpace_v6';
import PriceSpace_v7 from '../components/PriceSpace_v7';
import PriceSpace_v8 from '../components/PriceSpace_v8';
import PriceSpace_v9 from '../components/PriceSpace_v9';
import PriceTech_v1 from '../components/PriceTech_v1';
import PriceTech_v2 from '../components/PriceTech_v2';
import Price_exteriorTabs_v2 from '../components/Price_exteriorTabs_v2';
import Price_exterior_v1 from '../components/Price_exterior_v1';
import Price_exterior_v2 from '../components/Price_exterior_v2';
import price_exterior_v3 from '../components/price_exterior_v3';
import price_exterior_v4 from '../components/price_exterior_v4';
import Price_exterior_v5 from '../components/Price_exterior_v5';
import Price_exterior_v6 from '../components/Price_exterior_v6';
import Price_packet_v1 from '../components/Price_packet_v1';
import Price_spaceLists_v1 from '../components/Price_spaceLists_v1';
import Price_space_v1 from '../components/Price_space_v1';
import Price_space_v2 from '../components/Price_space_v2';
import Price_special_v1 from '../components/Price_special_v1';
import PublicPraise_v1 from '../components/PublicPraise_v1';
import PublicPraise_v2 from '../components/PublicPraise_v2';
import PublicPraise_v3 from '../components/PublicPraise_v3';
import PublicPraise_v4 from '../components/PublicPraise_v4';
import Recommend_v1 from '../components/Recommend_v1';
import RepairGuide_v1 from '../components/RepairGuide_v1';
import Result_v1 from '../components/Result_v1';
import ReturnTop from '../components/ReturnTop';
import Search_v1 from '../components/Search_v1';
import Security_v1 from '../components/Security_v1';
import Security_v2 from '../components/Security_v2';
import Security_v3 from '../components/Security_v3';
import ServiceDynamicsDetails_v1 from '../components/ServiceDynamicsDetails_v1';
import ServiceDynamics_v1 from '../components/ServiceDynamics_v1';
import ServiceRecall_v1 from '../components/ServiceRecall_v1';
import Share_v1 from '../components/Share_v1';
import show360detail_v1 from '../components/show360-detail_v1';
import show360_v1 from '../components/show360_v1';
import Sport_accord from '../components/Sport_accord';
import Subnav_v1 from '../components/Subnav_v1';
import SuppliesAtlas_v1 from '../components/SuppliesAtlas_v1';
import SuspensionhomePage from '../components/Suspension-homePage';
import Technology_accord from '../components/Technology_accord';
import TestDrive_v1 from '../components/TestDrive_v1';
import TestDrive_v2 from '../components/TestDrive_v2';
import TestDrive_v3 from '../components/TestDrive_v3';
import TestDrive_v4 from '../components/TestDrive_v4';
import TestShop_v1 from '../components/TestShop_v1';
import TextImage_v1 from '../components/TextImage_v1';
import TextMultiImage_v1 from '../components/TextMultiImage_v1';
import TextSingleImage_v1 from '../components/TextSingleImage_v1';
import TitleImageScrollTelling_v1 from '../components/TitleImageScrollTelling_v1';
import TitleSection_v1 from '../components/TitleSection_v1';
import VehiclesList_v1 from '../components/VehiclesList_v1';
import WallpaperVideo_homePage from '../components/WallpaperVideo_homePage';
import WallpaperVideo_v1 from '../components/WallpaperVideo_v1';

const components = new Map();
components.set('Activity_v1', Activity_v1);
components.set('Activity_v2', Activity_v2);
components.set('AllCar-homePage', AllCarhomePage);
components.set('Appliance_v1', Appliance_v1);
components.set('Banner_v1', Banner_v1);
components.set('Banner_v2', Banner_v2);
components.set('BlackEdition_v1', BlackEdition_v1);
components.set('BreezeHeader_v1', BreezeHeader_v1);
components.set('BuyCar_v1', BuyCar_v1);
components.set('BuyCar_v3', BuyCar_v3);
components.set('BuyCar_v4', BuyCar_v4);
components.set('BuyCar_v5', BuyCar_v5);
components.set('CarComparisonTab_v1', CarComparisonTab_v1);
components.set('CarComparisonTab_v2', CarComparisonTab_v2);
components.set('CarComparison_v1', CarComparison_v1);
components.set('CarRecommend_v1', CarRecommend_v1);
components.set('Center_v1', Center_v1);
components.set('Choose_v1', Choose_v1);
components.set('Close_v1', Close_v1);
components.set('Close_v2', Close_v2);
components.set('Contrast_v1', Contrast_v1);
components.set('Contrast_v2', Contrast_v2);
components.set('Detail_v1', Detail_v1);
components.set('Detail_v2', Detail_v2);
components.set('Drive_v1', Drive_v1);
components.set('EnvironmentAnnouncement_v1', EnvironmentAnnouncement_v1);
components.set('EnvironmentInformation_v1', EnvironmentInformation_v1);
components.set('Environment_v1', Environment_v1);
components.set('EventDisplay_v1', EventDisplay_v1);
components.set('ExhibitionHall', ExhibitionHall);
components.set('ExhibitionHall_v1', ExhibitionHall_v1);
components.set('ExhibitionHall_v2', ExhibitionHall_v2);
components.set('ExhibitionHall_v3', ExhibitionHall_v3);
components.set('Exterior_accord', Exterior_accord);
components.set('FinancialCalculator_v1', FinancialCalculator_v1);
components.set('FinancialService_v1', FinancialService_v1);
components.set('FindDealer_v1', FindDealer_v1);
components.set('Footer', Footer);
components.set('Footer-homePage', FooterhomePage);
components.set('FooterBlack_v2', FooterBlack_v2);
components.set('FooterFixmeau_v1', FooterFixmeau_v1);
components.set('Footer_black', Footer_black);
components.set('Footer_v1', Footer_v1);
components.set('FullVideo_v1', FullVideo_v1);
components.set('FullVideo_v2', FullVideo_v2);
components.set('H5_v1', H5_v1);
components.set('Header', Header);
components.set('Header-homePage', HeaderhomePage);
components.set('HeaderBlack_v2', HeaderBlack_v2);
components.set('Header_black', Header_black);
components.set('Header_v1', Header_v1);
components.set('HeroSupport_v1', HeroSupport_v1);
components.set('HomeBanner', HomeBanner);
components.set('HomeTabs_v1', HomeTabs_v1);
components.set('Home_v1', Home_v1);
components.set('HybridAlliance-homePage', HybridAlliancehomePage);
components.set('ImageGroup_v1', ImageGroup_v1);
components.set('ImageHorizontalScoll_v1', ImageHorizontalScoll_v1);
components.set('ImageReplace_v1', ImageReplace_v1);
components.set('ImageSlide_v1', ImageSlide_v1);
components.set('Inlet_v1', Inlet_v1);
components.set('InnerPageFace_v1', InnerPageFace_v1);
components.set('InnerPageLists_v1', InnerPageLists_v1);
components.set('InnerPageSensingLists_v1', InnerPageSensingLists_v1);
components.set('InnerPageSourceList_v1', InnerPageSourceList_v1);
components.set('InnerPageVideoLists_v1', InnerPageVideoLists_v1);
components.set('Insurance_v1', Insurance_v1);
components.set('Interaction_v1', Interaction_v1);
components.set('Interaction_v2', Interaction_v2);
components.set('Interior_accord', Interior_accord);
components.set('Interior_accord_v1', Interior_accord_v1);
components.set('Ipfilm_v1', Ipfilm_v1);
components.set('KnowledgeDetail_v1', KnowledgeDetail_v1);
components.set('Knowledge_v1', Knowledge_v1);
components.set('KvTabs_v4', KvTabs_v4);
components.set('kv_v1', kv_v1);
components.set('kv_v2', kv_v2);
components.set('kv_v3', kv_v3);
components.set('Kv_v4', Kv_v4);
components.set('LargeImageContentAll_v1', LargeImageContentAll_v1);
components.set('LifeValue-homePage', LifeValuehomePage);
components.set('Live_v1', Live_v1);
components.set('Manual_v1', Manual_v1);
components.set('Media_v1', Media_v1);
components.set('Media_v2', Media_v2);
components.set('MobileApp_v1', MobileApp_v1);
components.set('ModelComparison_v1', ModelComparison_v1);
components.set('NavigationBreezeHeader_v1', NavigationBreezeHeader_v1);
components.set('NavigationHeader_v1', NavigationHeader_v1);
components.set('NavigationMachine_v1', NavigationMachine_v1);
components.set('NavigationMachine_v2', NavigationMachine_v2);
components.set('NavigationMachine_v3', NavigationMachine_v3);
components.set('NavigationSide_v1', NavigationSide_v1);
components.set('NewsDetail_v1', NewsDetail_v1);
components.set('News_v1', News_v1);
components.set('NotFound_v1', NotFound_v1);
components.set('OneOnOne_v1', OneOnOne_v1);
components.set('OneOnOne_v2', OneOnOne_v2);
components.set('OneOnOne_v3', OneOnOne_v3);
components.set('Opention_v1', Opention_v1);
components.set('Operation', Operation);
components.set('Operation_footer', Operation_footer);
components.set('Operation_footer_v2', Operation_footer_v2);
components.set('Operation_footer_v5', Operation_footer_v5);
components.set('Operation_footer_v6', Operation_footer_v6);
components.set('Operation_footer_v7', Operation_footer_v7);
components.set('Operation_main', Operation_main);
components.set('Operation_Main_v2', Operation_Main_v2);
components.set('Operation_main_v3', Operation_main_v3);
components.set('OverlayImage_v1', OverlayImage_v1);
components.set('PartPrice_v1', PartPrice_v1);
components.set('Picture_v1', Picture_v1);
components.set('Policy_v1', Policy_v1);
components.set('Power_v1', Power_v1);
components.set('PriceControl_v1', PriceControl_v1);
components.set('priceExterior_v1', priceExterior_v1);
components.set('PriceExterior_v10', PriceExterior_v10);
components.set('PriceExterior_v11', PriceExterior_v11);
components.set('priceExterior_v2', priceExterior_v2);
components.set('PriceExterior_v3', PriceExterior_v3);
components.set('PriceExterior_v4', PriceExterior_v4);
components.set('PriceExterior_v5', PriceExterior_v5);
components.set('PriceExterior_v6', PriceExterior_v6);
components.set('PriceExterior_v7', PriceExterior_v7);
components.set('PriceExterior_v8', PriceExterior_v8);
components.set('PriceExterior_v9', PriceExterior_v9);
components.set('PricePower_v1', PricePower_v1);
components.set('PricePower_v2', PricePower_v2);
components.set('PricePower_v3', PricePower_v3);
components.set('PricePower_v4', PricePower_v4);
components.set('PricePower_v5', PricePower_v5);
components.set('PricePower_v6', PricePower_v6);
components.set('PricePower_v7', PricePower_v7);
components.set('PricePower_v8', PricePower_v8);
components.set('PriceSafety_v1', PriceSafety_v1);
components.set('PriceSpace_inlet', PriceSpace_inlet);
components.set('PriceSpace_v1', PriceSpace_v1);
components.set('PriceSpace_v10', PriceSpace_v10);
components.set('PriceSpace_v11', PriceSpace_v11);
components.set('PriceSpace_v3', PriceSpace_v3);
components.set('PriceSpace_v4', PriceSpace_v4);
components.set('PriceSpace_v5', PriceSpace_v5);
components.set('PriceSpace_v6', PriceSpace_v6);
components.set('PriceSpace_v7', PriceSpace_v7);
components.set('PriceSpace_v8', PriceSpace_v8);
components.set('PriceSpace_v9', PriceSpace_v9);
components.set('PriceTech_v1', PriceTech_v1);
components.set('PriceTech_v2', PriceTech_v2);
components.set('Price_exteriorTabs_v2', Price_exteriorTabs_v2);
components.set('Price_exterior_v1', Price_exterior_v1);
components.set('Price_exterior_v2', Price_exterior_v2);
components.set('price_exterior_v3', price_exterior_v3);
components.set('price_exterior_v4', price_exterior_v4);
components.set('Price_exterior_v5', Price_exterior_v5);
components.set('Price_exterior_v6', Price_exterior_v6);
components.set('Price_packet_v1', Price_packet_v1);
components.set('Price_spaceLists_v1', Price_spaceLists_v1);
components.set('Price_space_v1', Price_space_v1);
components.set('Price_space_v2', Price_space_v2);
components.set('Price_special_v1', Price_special_v1);
components.set('PublicPraise_v1', PublicPraise_v1);
components.set('PublicPraise_v2', PublicPraise_v2);
components.set('PublicPraise_v3', PublicPraise_v3);
components.set('PublicPraise_v4', PublicPraise_v4);
components.set('Recommend_v1', Recommend_v1);
components.set('RepairGuide_v1', RepairGuide_v1);
components.set('Result_v1', Result_v1);
components.set('ReturnTop', ReturnTop);
components.set('Search_v1', Search_v1);
components.set('Security_v1', Security_v1);
components.set('Security_v2', Security_v2);
components.set('Security_v3', Security_v3);
components.set('ServiceDynamicsDetails_v1', ServiceDynamicsDetails_v1);
components.set('ServiceDynamics_v1', ServiceDynamics_v1);
components.set('ServiceRecall_v1', ServiceRecall_v1);
components.set('Share_v1', Share_v1);
components.set('show360-detail_v1', show360detail_v1);
components.set('show360_v1', show360_v1);
components.set('Sport_accord', Sport_accord);
components.set('Subnav_v1', Subnav_v1);
components.set('SuppliesAtlas_v1', SuppliesAtlas_v1);
components.set('Suspension-homePage', SuspensionhomePage);
components.set('Technology_accord', Technology_accord);
components.set('TestDrive_v1', TestDrive_v1);
components.set('TestDrive_v2', TestDrive_v2);
components.set('TestDrive_v3', TestDrive_v3);
components.set('TestDrive_v4', TestDrive_v4);
components.set('TestShop_v1', TestShop_v1);
components.set('TextImage_v1', TextImage_v1);
components.set('TextMultiImage_v1', TextMultiImage_v1);
components.set('TextSingleImage_v1', TextSingleImage_v1);
components.set('TitleImageScrollTelling_v1', TitleImageScrollTelling_v1);
components.set('TitleSection_v1', TitleSection_v1);
components.set('VehiclesList_v1', VehiclesList_v1);
components.set('WallpaperVideo_homePage', WallpaperVideo_homePage);
components.set('WallpaperVideo_v1', WallpaperVideo_v1);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
